import { getOmpSearchString } from "@src/api/main/OMPTypes";
import { storePlacesApi, type ApiStorePlaceData } from "../../../../../../api/storePlaces";

/** Результат поиска ячейки размещения по скану. */
export type FinishedGoodsReceiptCellScanResult =
    | { type: "notFound" }
    | { type: "single"; cell: ApiStorePlaceData }
    | { type: "ambiguous"; cells: ApiStorePlaceData[] };

/**
 * Ищет доступную ячейку склада по скану штрихкода. \
 * Ожидаем ровно одну конечную ячейку по `SoNum` в пределах склада СГП.
 * @param barcode отсканированное значение
 * @param divisionCode код склада СГП
 */
export async function resolveFinishedGoodsReceiptCellScan(
    barcode: string,
    divisionCode: number,
): Promise<FinishedGoodsReceiptCellScanResult> {
    const soNum = getOmpSearchString(barcode, { cs: "case_dependent" });

    if (soNum == null || divisionCode === 0) {
        return { type: "notFound" };
    }

    const cells = await storePlacesApi.load({
        filter: {
            SoNum: soNum,
            DivisionCode: divisionCode,
            OnlyEndPoints: true,
        },
    });

    if (cells.length === 0) {
        return { type: "notFound" };
    }

    if (cells.length > 1) {
        return { type: "ambiguous", cells };
    }

    return { type: "single", cell: cells[0] };
}
